export function getDate(date, AddDayCount = 0) {
  if (!date) {
    date = new Date()
  }
  if (typeof date !== 'object') {
    date = date.replace(/-/g, '/')
  }
  const dd = new Date(date)

  dd.setDate(dd.getDate() + AddDayCount) // 获取AddDayCount天后的日期

  const y = dd.getFullYear()
  const lm = dd.getMonth() < 10 ? '0' + dd.getMonth() : dd.getMonth()
  const m =
    dd.getMonth() + 1 < 10 ? '0' + (dd.getMonth() + 1) : dd.getMonth() + 1 // 获取当前月份的日期，不足10补0
  const d = dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate() // 获取当前几号，不足10补0
  return {
    fullDate: y + '-' + m + '-' + d,
    year: y,
    lastMonth: lm,
    month: m,
    date: d,
    day: dd.getDay()
  }
}

// 获取日期
export function daysFormat(time) {
  var day = new Date(time)
  function timeAdd0(str) {
    if (str < 10) {
      str = '0' + str
    }
    return str
  }
  var y = day.getFullYear()
  var m = day.getMonth() + 1
  var d = day.getDate()
  return y + '-' + timeAdd0(m) + '-' + timeAdd0(d)
}

// 获取时间
export function dateFormat(time, addh = 0) {
  var date = new Date(time)
  function timeAdd0(str) {
    if (str < 10) {
      str = '0' + str
    }
    return str
  }
  var h =
    date.getHours() + addh > 23
      ? date.getHours() + addh - 24
      : date.getHours() + addh
  var mm = date.getMinutes()
  var s = date.getSeconds()
  return timeAdd0(h) + ':' + timeAdd0(mm) + ':' + timeAdd0(s)
}

// 获取月份
export function monthFormat(time) {
  var day = new Date(time)
  function timeAdd0(str) {
    if (str < 10) {
      str = '0' + str
    }
    return str
  }
  var y = day.getFullYear()
  var m = day.getMonth() + 1
  return y + '-' + timeAdd0(m)
}

// 获取星期几
export function weekFormat(time) {
  var day = new Date(time)
  var w = day.getDay()
  if (w === 0) {
    return '星期日'
  } else if (w === 1) {
    return '星期一'
  } else if (w === 2) {
    return '星期二'
  } else if (w === 3) {
    return '星期三'
  } else if (w === 4) {
    return '星期四'
  } else if (w === 5) {
    return '星期五'
  } else if (w === 6) {
    return '星期六'
  }
}

// 获取某月天数
export function getDaysInMonth(time) {
  var date = new Date(time)
  var y = date.getFullYear()
  var m = date.getMonth() + 1
  var days = new Date(y, m, 0).getDate()
  return days
}

// 获取某时间至当前时间的天数
export function getDayInterval(time1, time2) {
  var d1 = new Date(time1).getTime()
  var d2 = time2 ? new Date(time2).getTime() : new Date().getTime()
  var DayInterval = Math.round(Math.abs(d1 - d2) / (1000 * 60 * 60 * 24))
  return DayInterval
}

// 获取完整时间数字拼接字符串（不带连接符）
export function getStringTime(time) {
  var day = new Date(time)
  function timeAdd0(str) {
    if (str < 10) {
      str = '0' + str
    }
    return str
  }
  var y = day.getFullYear()
  var m = day.getMonth() + 1
  var d = day.getDate()
  var h = day.getHours()
  var mm = day.getMinutes()
  var s = day.getSeconds()
  var stringTime =
    '' +
    y +
    timeAdd0(m) +
    timeAdd0(d) +
    timeAdd0(h) +
    timeAdd0(mm) +
    timeAdd0(s)
  return stringTime
}
